import React from "react";
import createReactClass from "create-react-class";
import Circle from "./circle";

export default createReactClass({
  displayName: "Root",
  render() {
    if (
      !this.props.newArrivalCircles ||
      this.props.newArrivalCircles.length === 0
    )
      return "";
    const circles = this.props.newArrivalCircles.map(function(circle) {
      return <Circle circle={circle} key={circle.id} />;
    });
    return (
      <div>
        <article className="timeline-box">
          <h2 className="left">
            <i className="far fa-bell icon_blue" aria-hidden="true" />&nbsp;新着のサークル
          </h2>
          <div className="touch-wrap">
            <div className="touch">{circles}</div>
          </div>
        </article>
      </div>
    );
  },
});
